<template>
<div class="chapter">
<div class="inner_page">
<h1 class="subtitle">THE ONLY <br/>BUDGETING <br/>BOOK<br/>YOU’LL EVER <br/>NEED</h1>
<h1 class="subtitle1">How to Save Money and Manage <br/>Your Finances with a Personal <br/>Budget Plan That Works for You</h1>
<h1 class="subtitle2">TERE STOUFFER</h1>
<p class="center"><img alt="" src="OEBPS/images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?c0e8e086